import { DateTime } from 'luxon'
import { createSelector } from 'reselect'
import { getEntity } from './base'

export const getCurrentLoyaltyProgramPeriod = createSelector(
  [getEntity('LoyaltyProgramPeriod'), (_, params) => params],
  (periods, { userId }) =>
    periods.find(
      (period) =>
        period?.get('user') === userId && DateTime.fromISO(period.get('endAt')) > DateTime.local()
    )
)
